<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Back Order</h3>

      <div class="search_bar mb-1">
        <b-card>
          <b-row class="mb-1">
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.channel_selected" :options="channel_options" />
            </b-col>
            <!-- <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.client_selected"
                :options="client_options"
              />
            </b-col> -->
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.order_status_selected"
                :options="order_status_options" />
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" sm="12" md="4" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Vendor / Product SKU / Channel SKU"
                v-model="search_criteria.keyword" @keyup.enter="onSearch"></b-form-input>
            </b-col>

            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.start_at"></b-form-input>
            </b-col>

            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.end_at"></b-form-input>
            </b-col>

            <b-col class="text-left p-0">
              <b-button v-if="
                checkPermission(
                  $store.state.user_obj,
                  'Order Management',
                  'Back Order',
                  'Search',
                  true
                )
              " class="btn-action" size="sm" variant="info" @click="onSearch">
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>

              <b-button v-if="
                checkPermission(
                  $store.state.user_obj,
                  'Order Management',
                  'Back Order',
                  'Export CSV',
                  true
                )
              " class="btn-action" size="sm" variant="info" @click="exportCSV">
                Export
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div class="search_bar mb-3">
        <b-card>
          <b-row>
            <b-col cols="12" sm="12" md="3">
              <div class="cusor_pointer">
                <strong> BO Status </strong>

                <div class="row-status_cnt" @click="onSearchByStatus('order_status_selected', 'cancel')">
                  <div style="width: 150px;">NO BO (Pending)</div>
                  <div>
                    <span class="dot_white"></span>
                    <span>
                      {{ bo_cnts.no_bo_pending }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByStatus('order_status_selected', 'pending')">
                  <div style="width: 150px;">BO (Pending)</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ bo_cnts.bo_pending }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByStatus('order_status_selected', 'received')">
                  <div style="width: 150px;">BO (Available)</div>
                  <div>
                    <span class="dot_yellow"></span>
                    <span>
                      {{ bo_cnts.bo_available }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByStatus('order_status_selected', 'received')">
                  <div style="width: 150px;">BO (Committed)</div>
                  <div>
                    <span class="dot_green"></span>
                    <span>
                      {{ bo_cnts.bo_committed }}
                    </span>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <hr />

          <b-row class="mt-1 mb-1">
            <b-col class="">
              <b-button v-if="
                checkPermission(
                  $store.state.user_obj,
                  'Order Management',
                  'Back Order',
                  'Bulk Create BO',
                  true
                )
              " class="btn-action" size="sm" variant="info" @click="onBulkAction('create_bo')">
                Bulk Create BO
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div class="search_bar mb-3">
        <b-card>
          <b-row class="align-items-center">
            <b-col cols="12" md="8">
              <strong>Vendor Summary</strong>
              <div>Total Vendors: {{ vendor_count }}</div>
            </b-col>

            <b-col cols="12" md="4" class="text-md-right mt-2 mt-md-0">
              <b-button size="sm" variant="outline-info" @click="show_vendor_summary = !show_vendor_summary">
                {{ show_vendor_summary ? "▼ Hide Summary" : "▶ Show Summary" }}
              </b-button>
            </b-col>
          </b-row>

          <b-collapse :visible="show_vendor_summary" class="mt-3">
            <b-table small outlined striped hover responsive :items="vendor_summary" :fields="vendor_summary_fields"
              empty-text="No vendor summary">
              <template v-slot:cell(vendor)="data">
                {{ data.item.vendor ? data.item.vendor : "-" }}
              </template>

              <template v-slot:cell(product_count)="data">
                <div class="text-center">{{ data.item.product_count }}</div>
              </template>

              <template v-slot:cell(order_count)="data">
                <div class="text-center">{{ data.item.order_count }}</div>
              </template>
            </b-table>
          </b-collapse>
        </b-card>
      </div>

      <strong># of Records: {{ total_rows }}</strong>

      <b-row class="mb-1">
        <b-col cols="1" class="pr-0">
          <b-form-select size="sm" v-model="sel_table_limit" :options="[50, 100, 200, 500]"
            @change="getOrderMaster()" />
        </b-col>

        <b-col class="pl-0 pr-1">
          <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
            @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
        </b-col>
      </b-row>

      <b-table responsive small outlined striped hover :items="items" :fields="fields" :tbody-tr-class="rowClass">
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
        </template>

        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"></b-form-checkbox>
        </template>

        <template v-slot:cell(vendor)="data">
          {{ data.item.vendor ? data.item.vendor : "-" }}
        </template>

        <template v-slot:cell(order_date)="data">
          {{ displayDate(data.item.order_date) }}
        </template>

        <template v-slot:cell(other_sku)="data">
          {{ data.item.other_sku }}
          <span :key="virtual_sku_i" v-for="(virtual_sku, virtual_sku_i) in data.item.virtual_skus">
            <br />
            {{ virtual_sku }}
          </span>
        </template>

        <template v-slot:cell(no_of_order)="data">
          <router-link :to="{
            name: 'back_order_detail',
            params: {
              product_id: data.item.product_id,
              bo_status: data.item.bo_status
            }
          }">
            {{ data.item.orders.length }}
          </router-link>
        </template>

        <!-- <template v-slot:cell(payment_status)="data">
          -
        </template> -->

        <template v-slot:cell(order_import_status)="data">
          <div>
            <span class="span-status">{{ data.item.order_import_status }}</span>

            <span v-if="data.item.order_import_status == 'cancel'" class="dot_red"></span>
            <span v-if="data.item.order_import_status == 'hold'" class="dot_red"></span>
            <span v-if="data.item.order_import_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.order_import_status == 'received'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(stock_status)="data">
          <div>
            <span class="span-status">{{ data.item.stock_status }}</span>

            <span v-if="data.item.stock_status == '-'" class="dot_white"></span>
            <span v-if="data.item.stock_status == 'OOS'" class="dot_red"></span>
            <span v-if="data.item.stock_status == 'available'" class="dot_yellow"></span>
            <span v-if="data.item.stock_status == 'committed'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(fulfilment_status)="data">
          <div>
            <span class="span-status">{{ data.item.fulfilment_status }}</span>

            <span v-if="data.item.fulfilment_status == '-'" class="dot_white"></span>
            <span v-if="data.item.fulfilment_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.fulfilment_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.fulfilment_status == 'fulfiled'" class="dot_green"></span>
          </div>
        </template>

        <!-- <template v-slot:cell(delivery_status)="data">
          <div>
            <span v-if="data.item.delivery_status == '-'" class="dot_white"></span>
            <span v-if="data.item.delivery_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.delivery_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.delivery_status == 'fulfiled'" class="dot_green"></span>
          </div>
        </template> -->

        <template v-slot:cell(action)="data">
          <!-- <b-button
            v-if="data.item.order_import_status != 'received'"
            class="btn-action"
            size="sm"
            variant="success"
            :disabled="
              data.item.channel == 'Shopify' &&
                data.item.payment_status != 'paid'
            "
            @click="doReceiveOrder(data.item)"
            >Back Order</b-button
          > -->
        </template>
      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";

const fields = [
  {
    key: "chk_box",
    label: ""
  },
  {
    key: "vendor",
    label: "Vendor"
  },
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "channel_sku",
    label: "Channel SKU"
  },
  {
    key: "product_description",
    label: "Product Description"
  },
  {
    key: "no_of_item",
    label: "# of Items",
    class: "center_align"
  },
  {
    key: "no_of_order",
    label: "# of Orders",
    class: "center_align"
  },
  {
    key: "bo_status",
    label: "BO Status",
    class: "txt_camelcase center_align container-status"
  },
  {
    key: "action",
    label: "Action"
  }
];

const vendor_summary_fields = [
  {
    key: "vendor",
    label: "Vendor"
  },
  {
    key: "product_count",
    label: "# of Products",
    class: "center_align"
  },
  {
    key: "order_count",
    label: "# of Orders",
    class: "center_align"
  }
];

export default {
  name: "OrderMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService, global_function],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      show_vendor_summary: false,
      sel_table_limit: this.TABLE_LIMIT,
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      vendor_summary_fields: vendor_summary_fields,
      vendor_summary: [],
      vendor_count: 0,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      bo_cnts: {},
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        channel_selected: null
      },
      search_criteria: {
        keyword: "",
        channel_selected: null,
        client_selected: null,
        start_at: moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
        order_status_selected: null,
        stock_status_selected: null,
        fulfilment_status_selected: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      channel_options: [
        {
          value: null,
          text: "All Channel"
        }
      ],

      client_options: [
        {
          value: null,
          text: "All Client"
        }
      ],

      order_status_options: [
        {
          value: null,
          text: "All BO Status"
        },
        {
          value: "no_bo_pending",
          text: "No BO (Pending)"
        },
        {
          value: "bo_pending",
          text: "BO (Pending)"
        },
        {
          value: "bo_available",
          text: "BO (Available)"
        },
        {
          value: "bo_committed",
          text: "BO (Committed)"
        }
      ],
      stock_status_options: [
        {
          value: null,
          text: "All Stock Status"
        },
        {
          value: "-",
          text: "-"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "available",
          text: "Available"
        },
        {
          value: "committed",
          text: "Committed"
        }
      ],

      fulfilment_status_options: [
        {
          value: null,
          text: "All Fulfilment Status"
        },
        {
          value: "fulfiled",
          text: "Fulfilled"
        },
        {
          value: "pending",
          text: "Pending"
        }
      ],

      check_all_rows: false,
      outstanding_order_cnts: {},
      outstanding_stock_cnts: {},
      outstanding_fulfilment_cnts: {},
      initialized: false
    };
  },

  async created() {
    await this.getOrderMaster();

    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.channel_options.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name
      });
    }

    let clients_response = await this.getClients(this.$store.state.user_obj);
    for (let i in clients_response.clients) {
      this.client_options.push({
        value: clients_response.clients[i].id,
        text: clients_response.clients[i].full_name
      });
    }

    this.initialized = true;
  },

  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },

  watch: {
    check_all_rows: function (new_val, old_val) {
      console.log("check_all_rows");
      if (new_val == "all") {
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    }
  },

  methods: {
    exportCSV() {
      let export_url = process.env.VUE_APP_API_HOST + "/export_back_order.php?";
      this.search_criteria.client_id = this.$store.state.user_obj.client_id;

      for (let i in this.search_criteria) {
        if (this.search_criteria[i] != null) {
          export_url += `&${i}=` + this.search_criteria[i];
        }
      }

      export_url = encodeURI(export_url);
      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async bulkDownloadWayBill() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "hkt_bulk_waybill.php",
        data: {
          items: this.items
        }
      });

      if (response.data.url) {
        window.open(response.data.url, "_blank");
      }

      this.loader.hide();
    },

    async updateImportStatus(row_data, status) {
      if (status == "cancel") {
        return;
      }

      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_approval.php",
        data: {
          status: status,
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async doReceiveOrder(row_data) {
      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_receive.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Receive Order Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async doCommitOrder(row_data) {
      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_commit.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Commit Order Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async doCancelOrder(row_data) {
      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_cancel.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Cancel Order Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async doHoldOrder(row_data) {
      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_hold.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Cancel Order Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async doFulfillOrder(row_data) {
      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfil.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Fulfil Order Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async updateFulfillStatus(row_data) {
      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfill.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async onSearchByStatus(status_type, status_value) {
      this.search_criteria[status_type] = status_value;
      this.getOrderMaster();
    },

    async getOrderMaster() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "back_order_get.php",
        data: {
          offset: this.table_offset,
          limit: this.sel_table_limit,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.items = response.data.bo_products || [];
      this.bo_cnts = response.data.bo_cnts || {};
      this.vendor_summary = response.data.vendor_summary || [];
      this.vendor_count = response.data.vendor_count || 0;
      this.total_rows = this.items.length;

      if (this.loader) {
        this.loader.hide();
      }
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.currentPage = 1;
      this.table_offset = 0;
      this.getOrderMaster();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.sel_table_limit;
      this.getOrderMaster();
    },

    downloadWaybill(data) {
      let url = process.env.WAYBILL_HOST + "/waybill?";
      url += "id=" + data.tracking_number;
      window.open(url, "_blank");
    },

    async onBulkAction(bulk_action) {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let bo_products = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].bo_status == "no_bo_pending"
        ) {
          bo_products.push(this.items[i]);
        }
      }

      let action_urls = {
        create_bo: "back_order_generate.php"
      };

      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: action_urls[bulk_action],
        data: {
          bo_products: bo_products,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Bulk Update Success",
        variant: "success"
      });
      this.getOrderMaster();
    },

    async onBulkApprove() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let order_master_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status == "pending"
        ) {
          order_master_ids.push(this.items[i].id);
        }
      }

      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_approval.php",
        data: {
          status: status,
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async onBulkFulfill() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let order_master_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status != "pending" &&
          this.items[i].fulfilment_status == "pending"
        ) {
          order_master_ids.push(this.items[i].id);
        }
      }

      await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfill.php",
        data: {
          status: status,
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });

      this.getOrderMaster();
    },

    async pullShopifyOrders() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        url:
          this.NODEJS_API_URL +
          "/shopify_order_get?client_id=" +
          this.$store.state.user_obj.client_id,
        method: "GET",
        data: null
      }).then(response => {
        this.loader_full.hide();
        this.getOrderMaster();
        this.$eventHub.$emit("show_modal_message", {
          message_content: `New Orders: ${response.data.cnt_new_order} \r\n Updated Orders: ${response.data.cnt_update_order}`
        });
      });
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Upload Success",
          variant: "success"
        });
        if (response.data.auto_route_assigned_items) {
          this.$eventHub.$emit("show_auto_route_review", {
            items: response.data.auto_route_assigned_items
          });
        }
        this.getOrderMaster();
      }
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.span-status {
  display: none;
}

.container-status:hover .span-status {
  display: inline;
}

.row-status_cnt {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/BackOrders.vue